/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ArticleCommandeDto } from '../models/article-commande-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des articles de commandes
 */
@Injectable({
  providedIn: 'root',
})
export class ArticlesCommandesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation articleCommandeGetList
   */
  static readonly ArticleCommandeGetListPath = '/api/articles-commandes/list/{commandeId}';

  /**
   * Renvoie la liste des articles de la commande spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleCommandeGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleCommandeGetList$Response(params: {

    /**
     * Identifiant de la commande
     */
    commandeId: number;
  }): Observable<StrictHttpResponse<Array<ArticleCommandeDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ArticlesCommandesService.ArticleCommandeGetListPath, 'get');
    if (params) {
      rb.path('commandeId', params.commandeId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ArticleCommandeDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des articles de la commande spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `articleCommandeGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleCommandeGetList(params: {

    /**
     * Identifiant de la commande
     */
    commandeId: number;
  }): Observable<Array<ArticleCommandeDto>> {

    return this.articleCommandeGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ArticleCommandeDto>>) => r.body as Array<ArticleCommandeDto>)
    );
  }

  /**
   * Path part for operation articleCommandeLoadList
   */
  static readonly ArticleCommandeLoadListPath = '/api/articles-commandes/load-list/{commandeId}';

  /**
   * Renvoie la liste des articles de la commande spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleCommandeLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  articleCommandeLoadList$Response(params: {

    /**
     * Identifiant de la commande
     */
    commandeId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ArticlesCommandesService.ArticleCommandeLoadListPath, 'post');
    if (params) {
      rb.path('commandeId', params.commandeId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des articles de la commande spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `articleCommandeLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  articleCommandeLoadList(params: {

    /**
     * Identifiant de la commande
     */
    commandeId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.articleCommandeLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation articleCommandeGet
   */
  static readonly ArticleCommandeGetPath = '/api/articles-commandes/{id}';

  /**
   * Renvoie l'article de commande spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleCommandeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleCommandeGet$Response(params: {

    /**
     * Identifiant de l&#x27;article de commande spécifié
     */
    id: number;
  }): Observable<StrictHttpResponse<ArticleCommandeDto>> {

    const rb = new RequestBuilder(this.rootUrl, ArticlesCommandesService.ArticleCommandeGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ArticleCommandeDto>;
      })
    );
  }

  /**
   * Renvoie l'article de commande spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `articleCommandeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleCommandeGet(params: {

    /**
     * Identifiant de l&#x27;article de commande spécifié
     */
    id: number;
  }): Observable<ArticleCommandeDto> {

    return this.articleCommandeGet$Response(params).pipe(
      map((r: StrictHttpResponse<ArticleCommandeDto>) => r.body as ArticleCommandeDto)
    );
  }

  /**
   * Path part for operation articleCommandePut
   */
  static readonly ArticleCommandePutPath = '/api/articles-commandes/{id}';

  /**
   * Met à jour l'article de commande spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleCommandePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  articleCommandePut$Response(params: {

    /**
     * Identifiant de l&#x27;article de commande à mettre à jour
     */
    id: number;

    /**
     * Article de commande
     */
    body: ArticleCommandeDto
  }): Observable<StrictHttpResponse<ArticleCommandeDto>> {

    const rb = new RequestBuilder(this.rootUrl, ArticlesCommandesService.ArticleCommandePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ArticleCommandeDto>;
      })
    );
  }

  /**
   * Met à jour l'article de commande spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `articleCommandePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  articleCommandePut(params: {

    /**
     * Identifiant de l&#x27;article de commande à mettre à jour
     */
    id: number;

    /**
     * Article de commande
     */
    body: ArticleCommandeDto
  }): Observable<ArticleCommandeDto> {

    return this.articleCommandePut$Response(params).pipe(
      map((r: StrictHttpResponse<ArticleCommandeDto>) => r.body as ArticleCommandeDto)
    );
  }

  /**
   * Path part for operation articleCommandeDelete
   */
  static readonly ArticleCommandeDeletePath = '/api/articles-commandes/{id}';

  /**
   * Supprime l'article de commande spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleCommandeDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleCommandeDelete$Response(params: {

    /**
     * Identifiant de l&#x27;article de commande à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ArticlesCommandesService.ArticleCommandeDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'article de commande spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `articleCommandeDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleCommandeDelete(params: {

    /**
     * Identifiant de l&#x27;article de commande à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.articleCommandeDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation articleCommandePost
   */
  static readonly ArticleCommandePostPath = '/api/articles-commandes/{commandeId}';

  /**
   * Crée l'article de commande spécifié pour la commande spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleCommandePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  articleCommandePost$Response(params: {

    /**
     * Identifiant de la commande
     */
    commandeId: number;

    /**
     * Article de commande
     */
    body: ArticleCommandeDto
  }): Observable<StrictHttpResponse<ArticleCommandeDto>> {

    const rb = new RequestBuilder(this.rootUrl, ArticlesCommandesService.ArticleCommandePostPath, 'post');
    if (params) {
      rb.path('commandeId', params.commandeId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ArticleCommandeDto>;
      })
    );
  }

  /**
   * Crée l'article de commande spécifié pour la commande spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `articleCommandePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  articleCommandePost(params: {

    /**
     * Identifiant de la commande
     */
    commandeId: number;

    /**
     * Article de commande
     */
    body: ArticleCommandeDto
  }): Observable<ArticleCommandeDto> {

    return this.articleCommandePost$Response(params).pipe(
      map((r: StrictHttpResponse<ArticleCommandeDto>) => r.body as ArticleCommandeDto)
    );
  }

}
